/**
 * Nombre qui « compte » jusqu'à sa valeur (0 → valeur au montage, puis de
 * l'ancienne à la nouvelle valeur). Arrondi à l'entier ; coupé si l'appareil
 * demande de réduire les animations (`useCountUp`).
 */

import { useCountUp } from '@/features/skillcards/use-count-up';

export function CountUpNumber({
  value,
  duration = 1200,
  delay = 0,
}: {
  value: number;
  duration?: number;
  delay?: number;
}) {
  const shown = useCountUp(value, { duration, delay });
  return <span className="tabular-nums">{Math.round(shown)}</span>;
}
